// Live's image slot budget (#233, `image-form-capabilities/image-slots.ts`): a model takes up to
// `max_reference_images` images, and the brand logo, the selected product's images and the
// references share them. Ours has no brand logo yet (Coming soon) and one product image, the
// source; the references are the library's picks.
import type {
  CatalogImageModel,
  CatalogVideoModel,
  SourceRef,
} from "../../../api/generated/model";

/** How many images the model's change of an image takes (its `image.tweak` block). */
export function referenceCap(model: CatalogImageModel | CatalogVideoModel): number {
  return model.medium === "image" ? (model.modes["image.tweak"]?.references?.max ?? 0) : 0;
}

/** How many references may join the source within the cap. */
export function referencesLeft(cap: number, source: SourceRef | null): number {
  return Math.max(0, cap - (source === null ? 0 : 1));
}

export interface Images {
  source: SourceRef | null;
  references: SourceRef[];
}

/**
 * The images trimmed to another model's cap, in live's order (`trimImageSelectionToLimit`): the
 * references from the end first, then the product image. Live does it without a word.
 */
export function trimImages(images: Images, cap: number): Images {
  let overflow = (images.source === null ? 0 : 1) + images.references.length - cap;
  if (overflow <= 0) return images;
  const dropped = Math.min(overflow, images.references.length);
  const references = images.references.slice(0, images.references.length - dropped);
  overflow -= dropped;
  return { source: overflow > 0 ? null : images.source, references };
}
